import { render, staticRenderFns } from "./upsome.vue?vue&type=template&id=7dc701ab&scoped=true"
import script from "./upsome.vue?vue&type=script&lang=js"
export * from "./upsome.vue?vue&type=script&lang=js"
import style0 from "./upsome.vue?vue&type=style&index=0&id=7dc701ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc701ab",
  null
  
)

export default component.exports